<div class="container-fluid bg-white sticky-top header-dimension p-0">
  <header class="d-none d-lg-flex flex-wrap align-items-center justify-content-center justify-content-md-between h-100">
    <a class="d-flex align-items-center col-md-1 mb-2 mb-md-0 text-dark text-decoration-none" routerLink="/">
      <img alt="lm-icon" height="34" ngSrc="../../../../assets/images/shared/icon-logo.png" width="19" />
    </a>

    <div class="d-flex flex-row h-100 align-center" style="justify-content: space-between; gap: 3rem">
      @for (navItem of menuItems; track navItem) {
        <a [routerLink]="navItem.href" class="nav-link menu-item" routerLinkActive="active-link">
          <span>{{ navItem.name }}</span>
        </a>
      }
    </div>

    <div class="col-md-2 justify-content-end d-flex">
      <div class="d-flex align-center">
        <app-button [color]="'primary'" [link]="['/donate']" [scalped]="true" btnClass="header-donate-btn"
                    title="Donate">Donate
        </app-button>
        <div class="header-divider"></div>
        <a (click)="onNavigateToTribe()" class="nav-link menu-item d-flex align-center" type="button">Login</a>
      </div>
    </div>
  </header>

  <header class="d-lg-none d-md-block">
    <nav class="navbar navbar-expand-md fixed-top bg-white">
      <div class="container-fluid">
        <div class="mobile-header-icons">
          <a class="navbar-brand" routerLink="/">
            <img alt="icon-logo" height="34" ngSrc="../../../../assets/images/shared/icon-logo.png" width="19" />
          </a>

          <div class="d-flex align-center">
            <nav class="navbar navbar-expand-lg navbar-light">
              <app-button [color]="'primary'" [link]="['/donate']" [scalped]="true" btnClass="header-donate-btn"
                          title="Donate">Donate
              </app-button>
              <button
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
                class="navbar-toggler collapsed"
                data-bs-target="#navbarSupportedContent"
                data-bs-toggle="collapse"
                type="button"
              >
                <span class="navbar-toggler-icon" style="width: 30px; height: 25px"></span>
              </button>

              <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav mr-auto">
                  @for (navItem of menuItems; track navItem) {
                    <li class="nav-item">
                      <a [routerLink]="navItem.href" class="nav-link px-3 link-dark" routerLinkActive="active-link">
                        <span>{{ navItem.name }}</span>
                      </a>
                    </li>
                  }
                  <li><a (click)="onNavigateToTribe()" class="nav-link px-3 link-dark">Login</a></li>
                </ul>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </nav>
  </header>
</div>
